import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, DialogActions, DialogContent, } from '@mui/material';
import { ModalActionProps } from 'models/AutoModals';


type FilterDialogProps = {
    filterInputs: ReactNode,
} & ModalActionProps<{
    yard?: number,
    voyage?: number,
    shipper?: number,
    state?: string,
    photos?: boolean,
}>;

const FilterDialog = ({ filterInputs, onFinish, }: FilterDialogProps) => {
    const {t} = useTranslation('cars');

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const data = Object.fromEntries([...new FormData(event.currentTarget).entries()].map(e => [e[0], e[1] === '' ? undefined : e[1]])) as any;

        if (data.photos)
            data.photos = data.photos === 'true';

        onFinish(data);
    };

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                {filterInputs}
            </DialogContent>

            <DialogActions>
                <Button type="submit">{t('apply')}</Button>
            </DialogActions>
        </Box>
    );
};

export default FilterDialog;
